<template>
  <div>
    <particlesHeader :Title="'About Me'" :Size="13" />
    <section class="about-section content-section">
      <div class="container">
        <div class="row row-eq-height">
          <div class="col-sm-12 col-md-12 col-lg-4 profile-image-container glass-background ">
            <div class="image-inner-wrapper padded-with-20">
              <img class="profile-image img-responsive" src="../assets/about/IMG_053422.png" />
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-8">
            <div class="glass-background padded-with-20 about-text-container">
              Hi! My name is Mahmoud Salameh. I’m 25 Years old, I live in Amman which is the capital
              city
              of Jordan.
              Actually I come from another city - Alsalt but my work forced me to move here to the
              capital
              city of Great Jordan.
              <br />
              <br />I'm Graduated from Albalqa Applied University in 2015 with a Computer Science bachelor
              Certificate and a very good degree .
              <br />
              <br />now I'm working at
              <a
                class="technzone-link pink-link"
                target="_blank"
                href="https://www.technzone.com/"
              >Technzone</a>
              as a full-stack web developer with a very
              smart Colleagues
              , We are enjoying building and deploying web applications
              for verious fields , currently we are building a medical health care providing system
              named Labas head quartered in Suadia Arabia .
              <br />
              <br />I love my life! Everyday is a new experience! I love to help others and enjoy laughing
              and
              watching others having a good time! I love Eating delicious food and making a
              very reckless movements on the Chess board where I lost most of my dignity !
              <br />
              <br />

              <p class="about-post-script">
                PS : Most of my previous information are valid
                when written , don't expect
                me to remember coming back every year to update my age !
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="lower-parag-container glass-background padded-with-20">
              <p>
                I'm open-Minded and a very good listener, I would like to have a chit-chat with you,just reach me on
                any of my social media accounts (located at the bottom right corner of this page) .
                if you want a more formal way to get more information about me read
                <a
                  href="/dynamicPages/docs/CV.pdf"
                  target="_blank"
                  class="pink-link"
                >My CV</a>
                or visit
                <router-link class="pink-link" to="/contact">Contact Page</router-link>and send me something along with your
                email .
              </p>
            </div>
          </div>
        </div>
      </div>
      <br />
      <pageInlineNavigation :Next="'Contact'" :back="'About'" />
    </section>
  </div>
</template>

<script>
import particlesHeader from "../components/particlesHeader";
import pageInlineNavigation from "../components/pageInlineNavigation";
export default {
  components: { particlesHeader, pageInlineNavigation },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.about-container a {
  color: #f7475e;
  text-decoration: none;
  font-weight: bold;
}

.profile-image {
  width: 100%;
}

.about-post-script {
  color: #cecece;
  font-weight: bold;
  font-style: italic;
}

.lower-parag-container {
  margin-top: 20px;
}

.about-text-container,
.lower-parag-container {
  font-size: 12px;
  height: 100%;
}

.download-cv-container {
  margin-top: 30px;
}

.download-cv-container a {
  color: #f7475e;
  font-weight: bold;
}

.profile-image-container {
  display: -ms-flexbox;
  -ms-flex-pack: center;
  -ms-flex-align: center;
  display: -moz-box;
  -moz-box-pack: center;
  -moz-box-align: center;
  display: -webkit-box;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  display: box;
  box-pack: center;
  box-align: center;
}

@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .about-box {
    height: 240px;
  }

  .about-text-container,
  .last-paragraph {
    padding-bottom: 50px;
  }
  .about-box {
    /* height:auto; */
  }

  .image-inner-wrapper {
    height: 100%;
  }
}
</style>